import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/icons/actions/ico-btn-potvrdit.svg';
import _imports_1 from '@/assets/icons/ico-exclamation.svg';
const _hoisted_1 = { class: "layout__content__header" };
const _hoisted_2 = { class: "mb-1 mb-sm-4" };
const _hoisted_3 = {
    key: 0,
    class: "bg-success rounded w-25 p-2 d-flex align-items-center"
};
const _hoisted_4 = {
    key: 1,
    class: "bg-danger rounded w-25 p-2 d-flex align-items-center gap-2"
};
const _hoisted_5 = { class: "d-flex flex-column" };
import { generatedApiVersion } from "@/service/api";
import axios from "axios";
import { onMounted, ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'about',
    setup(__props) {
        const getCurrentApiVersion = async () => {
            const client = axios.create();
            client.defaults.headers.Pragma = undefined;
            client.defaults.headers.common["Expires"] = undefined;
            client.defaults.headers.common["Authorization"] = undefined;
            client.defaults.headers.common["Cache-Control"] = undefined;
            const response = await client.get(process.env.API_DEFINITION_URL ?? "https://test-api.iot.cra.cz/cxf/api/v1/swagger.json", { headers: {} });
            return await response.data.info.version;
        };
        const currentApiVersion = ref(null);
        onMounted(async () => {
            currentApiVersion.value = await getCurrentApiVersion();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "mb-1 mb-sm-4" }, "IoT Portál: About", -1)),
                _createElementVNode("h3", _hoisted_2, "Klient vygenerován pro verzi API: " + _toDisplayString(_unref(generatedApiVersion)), 1),
                (_unref(generatedApiVersion) === currentApiVersion.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
                        _createElementVNode("img", {
                            src: _imports_0,
                            style: { "width": "50px" }
                        }, null, -1),
                        _createElementVNode("span", { class: "font-weight-bold" }, "Klient je aktuální", -1)
                    ])))
                    : (_unref(generatedApiVersion) && currentApiVersion.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _cache[2] || (_cache[2] = _createElementVNode("img", {
                                class: "ml-2",
                                src: _imports_1,
                                style: { "width": "30px" }
                            }, null, -1)),
                            _createElementVNode("div", _hoisted_5, [
                                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-weight-bold" }, "Konflikt verzí", -1)),
                                _createElementVNode("span", null, "Verze API backendu: " + _toDisplayString(currentApiVersion.value), 1)
                            ])
                        ]))
                        : _createCommentVNode("", true)
            ]));
        };
    }
});
